import * as React from "react";
import { FormControl, Button, Glyphicon, FormGroup, InputGroup, HelpBlock } from "react-bootstrap";
import { IRccapAdditionalQuestionWithValidation } from "@nkr/models/index";

interface IProps {
    additionalQuestions: IRccapAdditionalQuestionWithValidation[],
    onChangeQuestion: (question: string, index: number) => void,
    onChangeAnswer?: (answer: string, index: number) => void,
    onRemoveQuestion: (index: number) => void,
    onAddQuestion: () => void,
}

class RccapAdditionalQuestions extends React.Component<IProps, {}> {
    handleChangeQuestion = (question: string, index: number) => {
        this.props.onChangeQuestion(question, index);
    }

    handleChangeAnswer = (answer: string, index: number) => {
        if (this.props.onChangeAnswer)
            this.props.onChangeAnswer(answer, index);
    }

    handleRemoveQuestion = (index: number) => {
        this.props.onRemoveQuestion(index);
    }

    handleAddQuestion = () => {
        this.props.onAddQuestion();
    }

    render = () => {
        const list = this.props.additionalQuestions.filter(x => x.isDeleted == false);

        return (
            <>
                {list.map((item, index) =>
                    <div key={index}>
                        <FormGroup key={index} style={{ marginBottom: 0 }} validationState={item.isValid ? null : "error"}>
                            <InputGroup>
                                <InputGroup.Addon>{index + 1}</InputGroup.Addon>
                                <FormControl
                                    value={item.question}
                                    onChange={(e: React.FormEvent<HTMLInputElement & FormControl>) => this.handleChangeQuestion(e.currentTarget.value, index)}
                                />
                                <InputGroup.Button>
                                    <Button bsStyle="danger" onClick={() => this.handleRemoveQuestion(index)}><Glyphicon glyph="remove" /></Button>
                                </InputGroup.Button>
                            </InputGroup>
                            {item.isValid == false && (
                                <div>
                                    <HelpBlock>Please specify question #{index + 1}...</HelpBlock>
                                </div>
                            )}
                        </FormGroup>

                        <FormGroup style={{ marginBottom: 0 }}>
                            <InputGroup className="pull-right" style={{ marginTop: 3, width: "95%" }}>
                                <InputGroup.Addon style={{ fontSize: 12 }}>Response</InputGroup.Addon>
                                <FormControl
                                    style={{ fontSize: 12 }}
                                    value={item.answer}
                                    onChange={(e: React.FormEvent<HTMLInputElement & FormControl>) => this.handleChangeAnswer(e.currentTarget.value, index)}
                                />
                            </InputGroup>
                        </FormGroup>

                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                    </div>
                )}

                {this.props.additionalQuestions.length == 0 && (
                    <div style={{ marginBottom: 20 }}>
                        No additional questions have been entered... click the plus (+) sign to add a question...
                    </div>
                )}

                <Button bsStyle="primary" bsSize="small" onClick={this.handleAddQuestion}><Glyphicon glyph="plus" /></Button>
            </>
        );
    }
}

export default RccapAdditionalQuestions;